<template>
  <div class="animated fadeIn advsttl-form">
    <b-card>
      <div slot="header">
        Cash Advance Settlement Form
        <div class="card-header-actions">
          <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
          <button class="btn btn-danger mr-1" @click="close()"><i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
        <b-col lg="8">
          <b-form-row>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend><label>Settlement Number</label></b-input-group-prepend>
                <b-form-input v-model="model.nomor" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend><label>Settlement Date</label></b-input-group-prepend>
                <b-form-input v-model="model.sttlDate" type="date" @change="tanggalBerubah"></b-form-input>
              </b-input-group>
            </b-col>
          </b-form-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label>Cash Adv. Owner</label></b-input-group-prepend>
                <b-form-input readonly v-model="model.crewinfo" :state="!$v.model.crewkey.$error"></b-form-input>
                <b-input-group-append v-if="adminAdv">
                  <b-btn text="Button" @click="lkuCrewShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><span class="p-2">Internal Budget</span></b-input-group-prepend>
                <b-form-input v-model="model.budgetinfo" readonly v-b-tooltip.hover :title="model.budgetname"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" variant="danger" @click="removeIB">
                    <i class="fa fa-times"></i>
                  </b-btn>
                </b-input-group-append>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuBudgetShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>

          <b-input-group>
            <b-input-group-prepend><label>Description</label></b-input-group-prepend>
            <b-form-input v-model="model.keterangan" :state="!$v.model.keterangan.$error"></b-form-input>
          </b-input-group>
          <b-form-row>
            <b-col cols="6">
              <b-input-group>
                <b-input-group-prepend><label>Settlement Amount</label></b-input-group-prepend>
                <b-input-group-prepend>
                  <b-form-select class="input-group-text" v-model="model.matauang" :plain="true" :options="currency" :state="!$v.model.matauang.$error"></b-form-select>
                </b-input-group-prepend>
                <my-number :minus="true" class="form-control text-right" separator="," v-model="model.jumlah" :precision="2" :state="!$v.model.jumlah.$error"></my-number>
              </b-input-group>
            </b-col>
            <b-col cols="5">
              <b-input-group>
                <b-input-group-prepend
                  ><span class="pt-2">Exch. Rate {{ model.matauang }} &nbsp;</span></b-input-group-prepend
                >
                <b-input-group-prepend>
                  <span class="input-group-text" style="width: 60px">{{ uanguser }}</span>
                </b-input-group-prepend>
                <my-number :disabled="model.matauang === uanguser" class="form-control text-right" separator="," v-model="model.ratekurs" :state="!$v.model.ratekurs.$error"></my-number>
              </b-input-group>
            </b-col>
          </b-form-row>
          <b-input-group>
            <b-input-group-prepend><label>iDocs Documents</label></b-input-group-prepend>
            <b-input-group-prepend>
              <span class="input-group-text">ADVANCE SETTLEMENT</span>
            </b-input-group-prepend>
            <b-form-input v-model="model.iDocsURL" placeholder="iDocs URL"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="show_iDocs()">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-input-group-append v-if="model.iDocsURL">
              <b-btn text="Button" variant="success" @click="open_iDocs()"> Open </b-btn>
            </b-input-group-append>
          </b-input-group>

          <!-- <b-input-group >
                    <b-input-group-prepend><span class="pt-2 pr-2">Pengembalian Nilai yg sudah dibiayakan(Non PJ)</span></b-input-group-prepend>
                    <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                    <my-number :minus="true" class="form-control text-right" separator="," v-model="model.nilaiNonPj" :precision="2" ></my-number>
                    <b-input-group-append><span class="input-group-text" >Return of Expensed Amount (meals,accomodation,transport,...etc)</span></b-input-group-append>
                </b-input-group> -->
        </b-col>
        <b-col md="4">
          <b-input-group>
            <b-input-group-prepend><label>Cash Flow</label></b-input-group-prepend>
            <b-form-input readonly v-model="model.cashflow" @keyup.13.native="showLkuCashflow('model')"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="showLkuCashflow('model')" id="apKodecash">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <v-dim :model="model" :key="updateDimHdr"></v-dim>
        </b-col>
      </b-row>
      <b-card no-body class="mb-1">
        <b-table class="mb-0" ref="tblAdvLines" outlined striped hover small style="font-size: smaller" :items="advLines.items" :fields="advLines.fields">
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(tglPaym)="data">
            <span v-if="data.item.tglPaym">{{ data.item.tglPaym | moment("DD MMM YYYY") }}</span>
          </template>
          <template v-slot:cell(advSettlAmt)="data">
            {{ data.item.advSettlAmt | numFormat }}
          </template>
          <template v-slot:cell(action)="data">
            <div class="text-center">
              <a href="javascript:void(0)" @click="editAdvLines(data.item, data.toggleDetails)">
                <i class="fa fa-pencil"></i>
              </a>
              |
              <a href="javascript:void(0)" class="text-danger" @click="delAdvLines(data.index)">
                <i class="fa fa-trash"></i>
              </a>
            </div>
          </template>
          <template v-slot:row-details="row">
            <b-card class="row-details-form">
              <b-row>
                <b-col md="8">
                  <b-form-row>
                    <b-col md="6">
                      <b-input-group>
                        <b-input-group-prepend><label>Cash Advance</label></b-input-group-prepend>
                        <b-form-input readonly v-model="advLinesObj.nomorAdv" @keyup.13.native="lkuAdvShow = true" :state="!$v.advLinesObj.advPayKey.$error"></b-form-input>
                        <b-input-group-append>
                          <b-btn text="Button" @click="lkuAdvShow = true" id="caNumber">
                            <i class="fa fa-search"></i>
                          </b-btn>
                        </b-input-group-append>
                      </b-input-group>
                    </b-col>
                  </b-form-row>
                  <b-input-group>
                    <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                    <b-form-input v-model="advLinesObj.keterangan" readonly></b-form-input>
                  </b-input-group>
                  <b-form-row>
                    <b-col md="6">
                      <b-input-group>
                        <b-input-group-prepend><label>Payment Date</label></b-input-group-prepend>
                        <b-form-input v-model="advLinesObj.tglPaym" type="date" disabled></b-form-input>
                      </b-input-group>
                    </b-col>
                    <b-col md="6">
                      <b-input-group>
                        <b-input-group-prepend><label>Payment Doc.</label></b-input-group-prepend>
                        <b-form-input v-model="advLinesObj.nomorPaym" readonly></b-form-input>
                      </b-input-group>
                    </b-col>
                  </b-form-row>
                </b-col>
                <b-col md="4">
                  <b-form-row>
                    <b-col md="11">
                      <b-input-group>
                        <b-input-group-prepend><label>Payment Amount</label></b-input-group-prepend>
                        <b-input-group-prepend>
                          <span class="input-group-text" style="width: 70px">{{ advLinesObj.matauang }}</span>
                        </b-input-group-prepend>
                        <my-number class="form-control text-right" v-model="advLinesObj.nilaiByr" :precision="2" readonly></my-number>
                      </b-input-group>
                    </b-col>
                  </b-form-row>
                  <b-form-row>
                    <b-col md="11">
                      <b-input-group>
                        <b-input-group-prepend><label>Un-Settle Amount</label></b-input-group-prepend>
                        <b-input-group-prepend>
                          <span class="input-group-text" style="width: 70px">{{ advLinesObj.matauang }}</span>
                        </b-input-group-prepend>
                        <my-number class="form-control text-right" v-model="advLinesObj.outstand" :precision="2" readonly></my-number>
                      </b-input-group>
                    </b-col>
                  </b-form-row>
                  <b-form-row>
                    <b-col md="11">
                      <b-input-group>
                        <b-input-group-prepend><label>Settlement Amount</label></b-input-group-prepend>
                        <b-input-group-prepend>
                          <span class="input-group-text" style="width: 70px">{{ advLinesObj.matauang }}</span>
                        </b-input-group-prepend>
                        <my-number :minus="true" class="form-control text-right" v-model="advLinesObj.advSettlAmt" :precision="2" :state="!$v.advLinesObj.advSettlAmt.$error"></my-number>
                      </b-input-group>
                    </b-col>
                  </b-form-row>
                </b-col>
              </b-row>
              <b-row class="justify-content-center mt-1">
                <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0" class="pt-2"></b-form-checkbox>
                <b-button v-if="saveEnabled" class="btn btn-info mr-1" @click="saveAdvLines()">Update</b-button>
                <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
              </b-row>
            </b-card>
          </template>
        </b-table>
        <b-row align-h="between">
          <b-col md="6">
            <b-button size="sm" class="ml-1" @click="addAdvLines" :disabled="!model.crewkey">Add Advance Detail</b-button>
          </b-col>
          <b-col md="4">
            <b-input-group>
              <b-input-group-prepend><label style="text-align: left; width: 158px; padding-left: 16px">subtotal Cash Advance</label></b-input-group-prepend>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 60px">{{ model.matauang }}</span>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.ttlAdvPay" :precision="2" disabled></my-number>
            </b-input-group>
          </b-col>
        </b-row>
      </b-card>
      <b-tabs card v-model="tabIndex">
        <b-tab no-body title="Expenses Detail">
          <b-table
            class="mb-0"
            ref="tblExpLines"
            outlined
            striped
            hover
            small
            style="font-size: smaller"
            :items="expLines.items"
            :fields="expLines.fields"
            :current-page="expLines.page"
            :per-page="expLines.limit"
          >
            <template v-slot:cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template v-slot:cell(nilaiexp)="data">
              {{ data.item.nilaiexp | numFormat("0,0.00") }}
            </template>
            <template v-slot:cell(pasalpph)="data">
              <span v-if="data.item.pph"> {{ data.item.pasalpph }} {{ data.item.pph | numFormat }}% </span>
            </template>
            <template v-slot:cell(grossup)="data">
              <span v-if="data.item.grossup == 1"><i class="fa fa-check"></i></span>
            </template>
            <template v-slot:cell(DimTableKey)="data">
              <span v-if="data.item.DimDuplikat" style="background-color:yellow;" v-b-tooltip.hover title="Shared Dimension">
                {{ data.item.DimTableKey }}
                <a v-if="(data.item.DimTableKey)" href="javascript:void(0)" @click="data.item.DimTableKey=''">
                  <i class="fa fa-window-close-o"></i>
                </a>
                <a v-else href="javascript:void(0)" @click="data.item.DimTableKey=data.item.DimTableKeyOri">
                  <i class="fa fa-undo"></i>
                </a>
              </span>
              <span v-else>{{ data.item.DimTableKey }}</span>
            </template>

            <template v-slot:cell(action)="data">
              <div class="text-center">
                <a href="javascript:void(0)" @click="editExpLines(data.item, data.toggleDetails)">
                  <i class="fa fa-pencil"></i>
                </a>
                |
                <a href="javascript:void(0)" class="text-danger" @click="delExpLines(data.index)">
                  <i class="fa fa-trash"></i>
                </a>
              </div>
            </template>
            <template v-slot:row-details="row">
              <b-card class="row-details-form">
                <b-row>
                  <b-col md="6" lg="7">
                    <b-input-group v-if="model.ibudghdkey">
                      <b-input-group-prepend><label>Intern.Budget Line</label></b-input-group-prepend>
                      <b-form-input v-model="expLinesObj.budgetline" :state="!$v.expLinesObj.ibudgdtkey.$error" readonly></b-form-input>
                      <b-input-group-append>
                        <b-btn text="Button" @click="showLkuBudgetIntern('expLinesObj')">
                          <i class="fa fa-search"></i>
                        </b-btn>
                      </b-input-group-append>
                      <b-form-checkbox v-model="expLinesObj.ibudgdtkeyflag" value="YES" unchecked-value="NO" class="ml-2 pt-2">NOT RELATED</b-form-checkbox>
                    </b-input-group>
                    <b-input-group>
                      <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                      <b-form-input v-model="expLinesObj.uraian" :state="!$v.expLinesObj.uraian.$error"></b-form-input>
                    </b-input-group>
                    <b-input-group>
                      <b-input-group-prepend><label>GL Account No.</label></b-input-group-prepend>
                      <b-form-input v-model="expLinesObj.kodeacc" :state="!$v.expLinesObj.kodeacc.$error"></b-form-input>
                      <b-form-input readonly v-model="expLinesObj.namaacc" @keyup.13.native="lkuCoaShow = true" :state="!$v.expLinesObj.kodeacc.$error" style="width: 50% !important"></b-form-input>
                      <b-input-group-append>
                        <b-btn text="Button" @click="lkuCoaShow = true" id="glAccount">
                          <i class="fa fa-search"></i>
                        </b-btn>
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-row>
                      <b-col cols="6">
                        <b-input-group>
                          <b-input-group-prepend><label>Amount</label></b-input-group-prepend>
                          <b-input-group-prepend>
                            <b-form-select style="width: 75px !important" v-model="expLinesObj.uangori" :plain="true" :options="currency" :state="!$v.expLinesObj.uangori.$error"></b-form-select>
                          </b-input-group-prepend>
                          <my-number
                            :minus="true"
                            class="form-control text-right"
                            separator=","
                            v-model="expLinesObj.nilaiori"
                            @change="calcTaxes()"
                            :precision="2"
                            :state="!$v.expLinesObj.nilaiori.$error"
                          ></my-number>
                        </b-input-group>
                      </b-col>
                      <b-col cols="5">
                        <b-input-group>
                          <b-input-group-prepend><span class="pt-2">Exch. Rate &nbsp;</span></b-input-group-prepend>
                          <b-input-group-prepend
                            ><span class="input-group-text" style="width: 60px">{{ expLinesObj.uangori }}</span></b-input-group-prepend
                          >
                          <b-input-group-prepend><span class="pt-2">&nbsp; to &nbsp;</span></b-input-group-prepend>
                          <b-input-group-prepend
                            ><span class="input-group-text" style="width: 60px">{{ model.matauang }}</span></b-input-group-prepend
                          >
                          <my-number
                            :disabled="expLinesObj.uangori === model.matauang"
                            class="form-control text-right"
                            separator=","
                            v-model="expLinesObj.kursori"
                            :state="!$v.expLinesObj.kursori.$error"
                          ></my-number>
                        </b-input-group>
                      </b-col>
                    </b-form-row>

                    <b-form-row>
                      <b-col md="6">
                        <b-input-group>
                          <b-input-group-prepend><label>Amount</label></b-input-group-prepend>
                          <b-input-group-prepend>
                            <span class="input-group-text" style="width: 75px">{{ model.matauang }}</span>
                          </b-input-group-prepend>
                          <my-number :minus="true" class="form-control text-right" readonly v-model="expLinesObj.nilai" :precision="2"></my-number>
                        </b-input-group>
                      </b-col>
                      <b-col md="6">
                        <b-input-group>
                          <b-input-group-prepend><label>Reference/evidence</label></b-input-group-prepend>
                          <b-form-input v-model="expLinesObj.reff"></b-form-input>
                        </b-input-group>
                      </b-col>
                    </b-form-row>

                    <b-form-row>
                      <b-col md="6">
                        <b-input-group>
                          <b-input-group-prepend><label>PPN Masukan</label></b-input-group-prepend>
                          <b-form-select v-model="expLinesObj.kenappn" :plain="true" :options="YesNo" @change="calcTaxes()"></b-form-select>
                          <b-input-group-prepend><span class="input-group-text" style="width: 70px">tarif</span></b-input-group-prepend>
                          <b-form-input v-model="expLinesObj.ppn" @change="calcTaxes()" type="number" :disabled="expLinesObj.kenappn != 1"></b-form-input>
                          <b-input-group-append>
                            <span class="input-group-text"><i class="fa fa-percent"></i></span
                          ></b-input-group-append>
                        </b-input-group>
                      </b-col>
                      <b-col md="5">
                        <b-input-group>
                          <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                          <b-form-checkbox id="chkGrossUp" class="ml-2 mt-2" v-model="expLinesObj.grossup" value="1" unchecked-value="0"> PPH Gross Up </b-form-checkbox>
                        </b-input-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col md="6">
                        <b-input-group>
                          <b-input-group-prepend><label>PPH dipotong</label></b-input-group-prepend>
                          <b-form-select v-model="expLinesObj.pasalpph" :plain="true" :options="lookupPPH"></b-form-select>
                          <b-input-group-prepend><span class="input-group-text" style="width: 70px">tarif</span></b-input-group-prepend>
                          <b-form-input v-model="expLinesObj.pph" type="number" @change="calcTaxes()"></b-form-input>
                          <b-input-group-append>
                            <span class="input-group-text"><i class="fa fa-percent"></i></span
                          ></b-input-group-append>
                        </b-input-group>
                      </b-col>
                      <b-col md="6">
                        <b-input-group>
                          <b-input-group-prepend>
                            <b-form-select style="width: 158px; font-size: small" v-model="calcPPh" :plain="true" :options="calcuationPPH"></b-form-select>
                          </b-input-group-prepend>
                          <b-input-group-prepend>
                            <span class="input-group-text" style="width: 60px">{{ model.matauang }}</span>
                          </b-input-group-prepend>
                          <my-number :minus="true" class="form-control text-right" v-model="expLinesObj.nilaipph" :precision="2" :readonly="calcPPh === 1"></my-number>
                        </b-input-group>
                      </b-col>
                    </b-form-row>
                  </b-col>
                  <b-col md="6" lg="5">
                    <b-input-group>
                      <b-input-group-prepend><label>Narasum/Talent</label></b-input-group-prepend>
                      <b-form-input v-model="expLinesObj.nama_narsum" @keyup.13.native="lkuNarasumShow = true" placeholder="NAMA" style="width: 35% !important" readonly></b-form-input>
                      <b-form-input v-model="expLinesObj.npwp_narsum" placeholder="NPWP" class="ml-1" readonly></b-form-input>
                      <b-input-group-append>
                        <b-btn text="Button" @click="lkuNarasumShow = true">
                          <i class="fa fa-search"></i>
                        </b-btn>
                      </b-input-group-append>
                    </b-input-group>
                    <v-dim :model="expLinesObj" :key="updateDimDtl"></v-dim>

                    <b-row class="justify-content-center mt-1">
                      <!-- <b-button v-if="saveEnabled" class="btn btn-info mr-1" @click="saveExpLines()">Update</b-button>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button> -->
                      <div style="width: 400px">
                        <b-input-group>
                          <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                          <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0" class="pt-2"></b-form-checkbox>
                          <b-input-group-append>
                            <b-button class="btn btn-success mr-1" @click="saveExpLines()">Update</b-button>
                          </b-input-group-append>
                          <b-input-group-append>
                            <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </div>
                    </b-row>
                  </b-col>
                </b-row>
              </b-card>
            </template>
          </b-table>
          <b-row>
            <b-col cols="5">
              <b-row>
                <b-button size="sm" class="ml-3" @click="addExpLines">Add Expense Detail</b-button>
                <!-- <b-button size="sm" class="ml-1" v-if="!adminAdv" @click="lkuExpnoteShow=true">Ambil Dari Catatan</b-button>                           -->
                <!-- <b-button size="sm" class="ml-1"  @click="lkuExpnoteShow=true">Ambil Dari Catatan</b-button>                           -->
                <div class="ml-2">
                  Showing {{ (expLines.page - 1) * expLines.limit + 1 }} to <span v-if="expLines.page * expLines.limit > expLines.total">{{ expLines.total }}</span>
                  <span v-else>{{ expLines.page * expLines.limit }}</span>
                  <strong> of {{ expLines.total }} entries </strong>
                </div>
              </b-row>
            </b-col>
            <b-col cols="2">
              <b-input-group>
                <b-input-group-prepend><span class="ml-4 pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                <b-form-select :options="[5, 10, 15, 20, 30, 40, 50]" :plain="true" v-model="expLines.limit" style="width: 80px" />
              </b-input-group>
            </b-col>
            <b-col cols="5">
              <b-pagination align="right" :total-rows="expLines.total" :per-page="expLines.limit" v-model="expLines.page"></b-pagination>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab no-body title="AP Payment" active>
          <b-table
            class="mb-0"
            ref="tblApPayment"
            outlined
            striped
            hover
            small
            style="font-size: smaller"
            :items="apPayment.items"
            :fields="apPayment.fields"
            :current-page="apPayment.page"
            :per-page="apPayment.limit"
          >
            <template v-slot:cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template v-slot:cell(nilaibayar)="data">
              {{ data.item.nilaibayar | numFormat }}
            </template>
            <template v-slot:cell(kurskeap)="data">
              {{ data.item.kurskeap | numFormat("0.000") }}
            </template>
            <template v-slot:cell(nilaibank)="data">
              {{ data.item.nilaibank | numFormat }}
            </template>
            <template v-slot:cell(selisihkurs)="data">
              {{ data.item.selisihkurs | numFormat("0,0.00") }}
            </template>

            <template v-slot:cell(action)="data">
              <div class="text-center">
                <a href="javascript:void(0)" @click="editApPayment(data.item, data.toggleDetails)">
                  <i class="fa fa-pencil"></i>
                </a>
                |
                <a href="javascript:void(0)" class="text-danger" @click="delApPayment(data.index)">
                  <i class="fa fa-trash"></i>
                </a>
              </div>
            </template>
            <template v-slot:row-details="row">
              <b-card no-body class="row-details-form">
                <b-row class="mt-2">
                  <b-col md="6">
                    <b-form-group label-cols="3" label-for="apInvoice" label="AP Invoice">
                      <b-input-group>
                        <b-form-input readonly v-model="apPaymentObj.invoice" @keyup.13.native="lkuApShow = true" :state="!$v.apPaymentObj.apinvkey.$error"></b-form-input>
                        <b-input-group-append>
                          <b-btn text="Button" @click="lkuApShow = true" id="apInvoice">
                            <i class="fa fa-search"></i>
                          </b-btn>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                    <b-form-group label-cols="3" label="Supplier/Vendor">
                      <b-form-input v-model="apPaymentObj.vendorinfo" readonly></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols="3" label="Description">
                      <b-form-input v-model="apPaymentObj.uraian" disabled></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols="3" label="AP Outstanding">
                      <b-input-group>
                        <b-input-group-prepend>
                          <span class="input-group-text" style="width: 70px">{{ apPaymentObj.matauang }}</span>
                        </b-input-group-prepend>
                        <my-number class="form-control text-right" separator="," v-model="apPaymentObj.outstand" :precision="2" disabled></my-number>
                      </b-input-group>
                    </b-form-group>
                    <b-form-group label-cols="3" label="Not Posted Settlemnt">
                      <b-input-group>
                        <b-input-group-prepend
                          ><span class="input-group-text" style="width: 70px">{{ apPaymentObj.matauang }}</span></b-input-group-prepend
                        >
                        <my-number class="form-control text-right" separator="," v-model="apPaymentObj.byr_semu" :precision="2" disabled></my-number>
                        <b-form-input v-model="apPaymentObj.byr_semu_doc" disabled></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label-cols="3" label="Payment in Original AP">
                      <b-input-group>
                        <b-input-group-prepend>
                          <span class="input-group-text" style="width: 70px">{{ apPaymentObj.matauang }}</span>
                        </b-input-group-prepend>
                        <my-number class="form-control text-right" separator="," v-model="apPaymentObj.nilaibayar" :precision="2" :state="!$v.apPaymentObj.nilaibayar.$error"></my-number>
                      </b-input-group>
                    </b-form-group>
                    <b-form-group label-cols="3" label="Payment in Advance Amt.">
                      <b-input-group>
                        <b-input-group-prepend>
                          <span class="input-group-text" style="width: 70px">{{ model.matauang }}</span>
                        </b-input-group-prepend>
                        <my-number class="form-control text-right" separator="," v-model="apPaymentObj.nilaibank" :precision="2" :state="!$v.apPaymentObj.nilaibank.$error"></my-number>
                      </b-input-group>
                    </b-form-group>
                    <b-form-group label-cols="3" label="Exchange Rate Advance to AP">
                      <b-input-group>
                        <b-input-group-prepend>
                          <span class="input-group-text pl-2 pr-2">{{ model.matauang }} to {{ apPaymentObj.matauang }}</span>
                        </b-input-group-prepend>
                        <my-number class="form-control text-right" separator="," v-model="apPaymentObj.kurskeap" :precision="6" :state="!$v.apPaymentObj.nilaibank.$error"></my-number>
                      </b-input-group>
                    </b-form-group>

                    <b-input-group v-if="model.ibudghdkey">
                      <b-input-group-prepend><label>Intern.Budget Line</label></b-input-group-prepend>
                      <b-form-input v-model="apPaymentObj.budgetline" :state="!$v.apPaymentObj.ibudgdtkey.$error" readonly></b-form-input>
                      <b-input-group-append>
                        <b-btn text="Button" @click="showLkuBudgetIntern('apPaymentObj')">
                          <i class="fa fa-search"></i>
                        </b-btn>
                      </b-input-group-append>
                      <b-form-checkbox v-model="apPaymentObj.ibudgdtkeyflag" value="YES" unchecked-value="NO" class="ml-2 pt-2">NOT RELATED</b-form-checkbox>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row class="justify-content-center mb-2">
                  <b-button v-if="saveEnabled" class="btn btn-info mr-1" @click="saveApPayment()">Update</b-button>
                  <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                </b-row>
              </b-card>
            </template>
          </b-table>
          <b-row>
            <b-col cols="5">
              <b-row>
                <b-button size="sm" class="ml-3" @click="addApPayment">Add AP Payment</b-button>
                <div class="ml-2">
                  Showing {{ (apPayment.page - 1) * apPayment.limit + 1 }} to <span v-if="apPayment.page * apPayment.limit > apPayment.total">{{ apPayment.total }}</span>
                  <span v-else>{{ apPayment.page * apPayment.limit }}</span>
                  <strong> of {{ apPayment.total }} entries </strong>
                </div>
              </b-row>
            </b-col>
            <b-col cols="2">
              <b-input-group>
                <b-input-group-prepend><span class="ml-4 pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                <b-form-select :options="[5, 10, 15, 20, 25]" :plain="true" v-model="apPayment.limit" style="width: 80px" />
              </b-input-group>
            </b-col>
            <b-col cols="5">
              <b-pagination align="right" :total-rows="apPayment.total" :per-page="apPayment.limit" v-model="apPayment.page"></b-pagination>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
      <b-row align-h="between" class="mt-1">
        <b-col lg="8" xl="7">
          <b-form-row>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend><label style="width: 160px">Return Cash Excees</label></b-input-group-prepend>
                <b-input-group-prepend>
                  <span class="input-group-text" style="width: 60px">{{ model.matauang }}</span>
                </b-input-group-prepend>
                <my-number class="form-control text-right" separator="," v-model="model.cashvault" :precision="2" readonly></my-number>
              </b-input-group>
            </b-col>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend><label style="width: 160px">Additional Cash Need</label></b-input-group-prepend>
                <b-input-group-prepend>
                  <span class="input-group-text" style="width: 60px">{{ model.matauang }}</span>
                </b-input-group-prepend>
                <my-number class="form-control text-right" separator="," v-model="model.balandue" :precision="2" readonly></my-number>
              </b-input-group>
            </b-col>
          </b-form-row>
        </b-col>
        <b-col md="4">
          <div class="text-right">
            <b-input-group>
              <b-input-group-prepend><label style="text-align: left; width: 158px; padding-left: 16px">subtotal Expenses</label></b-input-group-prepend>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 60px">{{ model.matauang }}</span>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.ttlExpen" :precision="2" disabled></my-number>
            </b-input-group>
          </div>
        </b-col>
      </b-row>
      <b-row class="justify-content-center mb-2">
        <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
        <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0" class="pt-2"></b-form-checkbox>
        <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
        <button class="btn btn-primary" @click="close()"><i class="fa fa-close"></i> Close</button>
      </b-row>
    </b-card>
    <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
      <lku-crew @click="onSelectLkuCrew" :formdata="lkuCrewData"></lku-crew>
    </b-modal>
    <b-modal v-model="lkuCashflowShow" size="lg" :hide-footer="true" title="List of Cashflow Account" :centered="true">
      <lku-cashflow @click="onSelectLkuCashflow" :formdata="lkuCashflowData"></lku-cashflow>
    </b-modal>
    <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
      <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
    </b-modal>
    <!-- <b-modal v-model="lkuAdvShow" size="lg" :hide-footer="true" title="List of Cash Advance Payment" :key="model.crewkey" :key="`${model.crewinfo}+${model.matauang}`" :centered="true" :lazy="true"> -->
    <b-modal v-model="lkuAdvShow" size="lg" :hide-footer="true" title="List of Cash Advance Payment" :key="model.crewkey" :centered="true" :lazy="true">
      <lku-adv @click="onSelectLkuAdv" :crewkey="model.crewkey" :crewinfo="model.crewinfo" :matauang="model.matauang" :formdata="lkuAdvData"></lku-adv>
    </b-modal>
    <b-modal v-model="lkuNarasumShow" size="lg" :hide-footer="true" title="Daftar Narasumber" :centered="true">
      <lku-narasumber @click="onSelectLkuNarasumber"></lku-narasumber>
    </b-modal>
    <b-modal v-model="lkuApShow" size="lg" :hide-footer="true" title="List of AP Outstanding" :centered="true" :lazy="true">
      <lku-ap @click="onSelectLkuAp" :formdata="lkuApData"></lku-ap>
    </b-modal>
    <b-modal v-model="lkuBudgetShow" size="lg" :hide-footer="true" title="List of Internal Budget" :centered="true">
      <lku-budgetinternal @click="onSelectLkuBudget"></lku-budgetinternal>
    </b-modal>
    <b-modal v-model="lkuBudgetInternShow" size="lg" :hide-footer="true" title="Internal Budget Items" :centered="true">
      <lku-budgetinternalline @click="onSelectLkuBudgetIntern" :ibudghdkey="model.ibudghdkey" :formdata="lkuBudgetInternData" :key="model.ibudghdkey"></lku-budgetinternalline>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>
<style lang="scss">
.advsttl-form {
  table {
    td:nth-child(1) {
      width: auto;
    }
    td:nth-child(2) {
      width: auto;
    }
    td {
      .dropdown-item {
        padding: 0.1rem 1.5rem !important;
        font-size: smaller !important;
      }
    }
  }
  .input-group {
    padding-bottom: 2px;
    .input-group-prepend {
      label {
        padding-top: 5px;
        padding-right: 5px;
        width: 130px;
      }
    }
  }
  .form-group {
    margin-bottom: 2px;
    .input-group {
      padding-bottom: 0;
    }
  }
  .row-details-form {
    label {
      text-align: right !important;
    }
    legend {
      text-align: right !important;
    }
    .input-group {
      .input-group-prepend {
        label {
          width: 100px;
        }
      }
    }
  }
}
</style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuAp from "../lookup/lkuApLazzy";
import lkuAdv from "../lookup/lkuAdvPayLazzy";
import lkuBudgetinternal from "../lookup/lkuBudgetinternal";
import lkuBudgetinternalline from "../lookup/lkuBudgetinternallineLazzy";
import lkuCrew from "../lookup/lkuCrewFull";
import lkuCashflow from "../lookup/lkuCashflowLazzy";
import lkuCoa from "../lookup/lkuCoa";
// import lkuExpnote from "../lookup/lkuExpensenote";
import lkuNarasumber from "./narasumberLKU";
import advsettle from "../../apis/advsettle";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, requiredIf, minValue, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { myNumber, vDim, lkuAp, lkuAdv, Loading, lkuBudgetinternal, lkuBudgetinternalline, lkuCrew, lkuCashflow, lkuCoa, lkuNarasumber },
  mixins: [validationMixin],
  validations: {
    model: {
      crewkey: { required },
      keterangan: { required },
      sttlDate: { required },
      matauang: { required },
      jumlah: { required, minValue: minValue(1) },
      ratekurs: { required, minValue: minValue(0.00000001) },
    },
    advLinesObj: {
      advPayKey: { required },
      advSettlAmt: { required, minValue: minValue(0.00000001) },
    },
    expLinesObj: {
      kodeacc: { required },
      uraian: { required },
      uangori: { required },
      kursori: { required, minValue: minValue(0.00000001) },
      nilaiori: { required },
      ibudgdtkey: {
        required: function () {
          if (this.model.ibudghdkey) {
            if (this.expLinesObj.ibudgdtkey) {
              if (this.expLinesObj.ibudghdkey == "N/A") return true;
              else {
                if (this.model.ibudghdkey == this.expLinesObj.ibudghdkey) {
                  return true;
                } else {
                  toastr.error(`Budget Line not from Internal Budget`, "Line/Detail Expenses", 10000);
                  return false;
                }
              }
            } else return false;
          } else return true;
        },
      },
    },
    apPaymentObj: {
      apinvkey: { required },
      nilaibayar: { required, minValue: minValue(0.01) },
      nilaibank: { required, minValue: minValue(0.01) },
      kurskeap: { required, minValue: minValue(0.001) },
      ibudgdtkey: {
        required: function () {
          if (this.model.ibudghdkey) {
            if (this.apPaymentObj.ibudgdtkey) {
              if (this.apPaymentObj.ibudghdkey == "N/A") return true;
              else {
                if (this.model.ibudghdkey == this.apPaymentObj.ibudghdkey) {
                  return true;
                } else {
                  toastr.error(`Budget Line not from Internal Budget`, "AP Settlement Detail", 10000);
                  return false;
                }
              }
            } else return false;
          } else return true;
        },
      },
    },
  },
  data() {
    return {
      watching_pasalpph: false,
      inputBerlanjut: 1,
      inputLineBerlanjut: 1,
      isLoading: false,
      saveEnabled: true,
      lkuBudgetShow: false,
      lkuBudgetInternShow: false,
      lkuBudgetInternData: {},
      lkuBudgetInternCaller: "",
      lkuApShow: false,
      lkuApData: {},
      lkuAdvShow: false,
      lkuAdvData: {},
      lkuCashflowData: {},
      lkuCashflowShow: false,
      lkuCashflowCaller: "model",
      lkuCrewData: {},
      lkuCrewShow: false,
      lkuExpnoteShow: false,
      updateDimHdr: false,
      updateDimDtl: true,
      tarifPPN: this.$store.state.user.tarifppn || 10,
      tahun: (this.$store.state.user.tglaktif || "").substring(0, 4),
      coa: [],
      uanguser: this.$store.state.user.matauang,
      currency: [{ value: "IDR", text: "IDR" }],
      YesNo: [
        { value: 1, text: "YES" },
        { value: 0, text: "NO" },
      ],
      advLines: {
        items: [],
        selected: {},
        fields: [
          { key: "index", label: "No.", thStyle: "width:40px" },
          {
            key: "nomorAdv",
            label: "Advance Request#",
            thStyle: "width:100px",
          },
          {
            key: "keterangan",
            label: "Description",
          },
          {
            key: "tglPaym",
            label: "Payment Date",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "nomorPaym",
            label: "Payment Doc.",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "advSettlAmt",
            label: "Amount",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          },
        ],
        total: 0,
      },
      expLines: {
        items: [],
        selected: {},
        fields: [
          { key: "index", label: "No.", thStyle: "width:40px" },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "glAccount",
            label: "GL Account",
          },
          {
            key: "nilaiexp",
            label: "Amount",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "reff",
            label: "Reference Doc.",
            thStyle: "width:180px",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "DimTableKey",
            label: "Dimenseion Key",
            thStyle: "width:180px",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          },
        ],
        page: 1,
        limit: 10,
        total: 0,
      },
      apPayment: {
        items: [],
        selected: {},
        fields: [
          { key: "index", label: "No.", thStyle: "width:40px" },
          {
            key: "nomor",
            thStyle: "width:150px",
            label: "AP Number",
          },
          {
            key: "invoice",
            label: "Invoice Number",
            thStyle: "width:150px",
            sortable: true,
          },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
          },
          {
            key: "nilaibayar",
            label: "Settlement Original Amt.",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "kurskeap",
            label: "Exch.Rate to Original",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "nilaibank",
            label: "Settlement in Bank/Cash Amt.",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "selisihkurs",
            label: "Gain/(Loss) Exch.Rate",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "cashflow",
            label: "Cashflow Acc.",
            thStyle: "width:200px",
            sortable: true,
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          },
        ],
        page: 1,
        limit: 5,
        total: 0,
      },
      calcPPh: 1,
      calcuationPPH: [
        { value: 1, text: "Nilai PPH(Otomatis)" },
        { value: 0, text: "Nilai PPH(Manual)" },
      ],
      lookupPPH: [],
      model: {
        crewkey: "",
        ibudghdkey: "",
        keterangan: "",
        sttlDate: "",
        kodecash: "",
        uangori: this.$store.state.user.matauang,
        jumlah: 0,
        final: 1,
        jenisadv: "",
        nilaiNonPj: 0,
        ratekurs: 1,
        DimTableKey: "",
        iDocsURL: "",
      },
      advLinesObj: {
        advPayKey: "",
        advSettlAmt: 0,
        DimTableKey: "",
      },
      expLinesObj: {
        kodeacc: "",
        ibudgdtkey: "",
        ibudgdtkeyflag: "YES",
        uraian: "",
        namaacc: "",
        glAccount: "",
        uangori: this.$store.state.user.matauang,
        kursori: 1,
        grossup: 0,
        nilai: 0,
        nilainett: 0,
        dpp: 0,
        ppn: 11,
        kenappn: 0,
        nilaippn: 0,
        pasalpph: "NO WHT",
        nilaipph: 0,
        pph: 0,
        nilaiori: 0,
        DimTableKey: "",
        nama_narsum: "",
        npwp_narsum: "",
        norek_narsum: "",
        norek_bank_narsum: "",
        norek_nasabah_narsum: "",
      },

      apPaymentObj: { apinvkey: "", kodecash: "", vendor: "", vendorinfo: "", nilaibayar: 0, nilaibank: 0, kurskeap: 1, kurspost: 1, selisihkurs: 0, ibudgdtkey: "", ibudgdtkeyflag: "YES" },
      tabIndex: 0,
      adminAdv: true,
      lkuCoaShow: false,
      lkuNarasumShow: false,
      inputBerlanjut: 0,
      inputLineBerlanjut: 1,
    };
  },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    invalidApPayment() {
      this.$v.apPaymentObj.$touch();
      return this.$v.apPaymentObj.$invalid;
    },
    invalidAdvLines() {
      this.$v.advLinesObj.$touch();
      return this.$v.advLinesObj.$invalid;
    },
    invalidExpLines() {
      this.$v.expLinesObj.$touch();
      return this.$v.expLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    nilaiOriExp() {
      return this.expLinesObj.nilaiori;
    },
    ratekursExp() {
      return this.expLinesObj.kursori;
    },
    // nilai(){
    //     return this.expLinesObj.pasalpph;
    // },
    // pasalpph(){
    //     return this.expLinesObj.pasalpph;
    // },
  },
  watch: {
    nilaiOriExp: function (newval) {
      this.expLinesObj.nilai = newval * this.ratekursExp;
    },
    ratekursExp: function (newval) {
      this.expLinesObj.nilai = newval * this.nilaiOriExp;
    },
    // nilai: function(newval) {
    //     setTimeout(() => {
    //         this.calcTaxes();
    //     }, 100);
    // },
    // pasalpph: function(newval) {
    //     const item = this.lookupPPH.find(p => p.value==newval);
    //     this.expLinesObj.pph=item.pph;
    //     setTimeout(() => {
    //         this.calcTaxes();
    //     }, 100);
    // },
    "expLinesObj.grossup": function (newval) {
      setTimeout(() => {
        this.calcTaxes();
      }, 100);
    },
    "expLinesObj.nilai": function (newval) {
      setTimeout(() => {
        this.calcTaxes();
      }, 100);
    },
    "expLinesObj.pph": function (newval) {
      setTimeout(() => {
        this.calcTaxes();
      }, 100);
    },
    "expLinesObj.ppn": function (newval) {
      setTimeout(() => {
        this.calcTaxes();
      }, 100);
    },
    "model.ibudghdkey": function (newval) {
      // setTimeout(() => {
      this.expLinesObj.ibudgdtkeyflag == "YES";
      this.expLinesObj.ibudghdkey = "N/A";
      this.expLinesObj.ibudgdtkey = "N/A";
      this.expLinesObj.budgetline = "";
      // this.expLines.items.forEach((line)=>{
      //     line.ibudgdtkey='';
      //     line.budgetline='';
      // });

      this.apPaymentObj.ibudgdtkeyflag == "YES";
      this.apPaymentObj.ibudghdkey = "N/A";
      this.apPaymentObj.ibudgdtkey = "N/A";
      this.apPaymentObj.budgetline = "";
      // this.apPayment.items.forEach((line)=>{
      //     line.ibudgdtkey='';
      //     line.budgetline='';
      // });
      // }, 200);
    },
    "expLinesObj.ibudgdtkeyflag": function (newval) {
      setTimeout(() => {
        if (this.expLinesObj.ibudgdtkeyflag == "YES") {
          this.expLinesObj.ibudghdkey = "N/A";
          this.expLinesObj.ibudgdtkey = "N/A";
          this.expLinesObj.budgetline = "";
        } else {
          this.expLinesObj.ibudghdkey = this.expLinesObj.ibudghdkey == "N/A" ? "" : this.expLinesObj.ibudghdkey;
          this.expLinesObj.ibudgdtkey = this.expLinesObj.ibudgdtkey == "N/A" ? "" : this.expLinesObj.ibudgdtkey;
          this.expLinesObj.budgetline = this.expLinesObj.ibudgdtkey == "N/A" ? "" : this.expLinesObj.budgetline;
        }
        this.$forceUpdate();
      }, 100);
    },
    "apPaymentObj.ibudgdtkeyflag": function (newval) {
      setTimeout(() => {
        if (this.apPaymentObj.ibudgdtkeyflag == "YES") {
          this.apPaymentObj.ibudghdkey = "N/A";
          this.apPaymentObj.ibudgdtkey = "N/A";
          this.apPaymentObj.budgetline = "";
        } else {
          this.apPaymentObj.ibudghdkey = this.apPaymentObj.ibudghdkey == "N/A" ? "" : this.apPaymentObj.ibudghdkey;
          this.apPaymentObj.ibudgdtkey = this.apPaymentObj.ibudgdtkey == "N/A" ? "" : this.apPaymentObj.ibudgdtkey;
          this.apPaymentObj.budgetline = this.apPaymentObj.ibudgdtkey == "N/A" ? "" : this.apPaymentObj.budgetline;
        }
        this.$forceUpdate();
      }, 100);
    },
  },
  created: async function () {
    if (this.$route.params.advSttlKey) {
      toastr.info("Loading ADVANCE SETTLEMENT Detail, please wait");
      try {
        const [b, c, data] = await Promise.all([advsettle.currency(), advsettle.pasalpph(), advsettle.detail(this.$route.params)]);
        this.currency = b;
        this.lookupPPH = c;
        const row = data[0][0];
        // this.saveEnabled=(row.posting == 0) ;
        if (row.posting == 1 || row.nomorbank) this.saveEnabled = false;
        row.sttlDate = row.sttlDate ? moment(row.sttlDate).format("YYYY-MM-DD") : "";
        for (var key in row) {
          this.model[key] = row[key];
        }
        this.tanggalBerubah();
        this.expLines.items = data[1];
        for (let index = 0; index < this.expLines.items.length; index++) {
          const line = this.expLines.items[index];
          const DimTableKey = line.DimTableKey;
          line.DimTableKeyOri = DimTableKey;
          const idxDuplikat = this.expLines.items.findIndex((item) => item.DimTableKey == DimTableKey);
          if (idxDuplikat > 0 && idxDuplikat !== index) {
            line.DimDuplikat = true;
          }
        }
        this.advLines.items = data[2];
        this.apPayment.items = data[3];
        this.expLines.total = this.expLines.items.length;
        this.calcDtlExp();
        this.calcDtlAdv();
        this.updateDimHdr = !this.updateDimHdr;
        // this.$forceUpdate();
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    } else {
      if (this.$route.params.crewkey) {
        this.adminAdv = false;
        const { user } = this.$store.state;
        this.model.crewinfo = user.full_name + " | " + user.crewnik.trim();
        this.model.crewkey = user.crewkey;
        const dim = this.dimension.find((d) => d.RelatedObj == "department");
        if (dim) {
          this.model[`${dim.value}`] = user.departkd;
          this.model[`${dim.value}Txt`] = user.departemen;
          this.model[`${dim.value}Info`] = user.departkd + " | " + user.departemen;
        }
      }

      this.model.sttlDate = moment().format("YYYY-MM-DD");
      this.tahun = this.model.sttlDate.substring(0, 4);
      this.model.matauang = this.uanguser;
      this.model.ratekurs = 1;
      const [b, c, e] = await Promise.all([advsettle.currency(), advsettle.pasalpph(), advsettle.getcoa({ tahun: this.tahun })]);
      this.currency = b;
      this.lookupPPH = c;
      this.coa = e;
    }
    this.tabIndex = 0;
    this.$watch("expLinesObj.pasalpph", function (newval) {
      if (this.watching_pasalpph == true) {
        const item = this.lookupPPH.find((p) => p.value == newval);
        if (item) {
          this.expLinesObj.pph = item.pph;
          setTimeout(() => {
            this.calcTaxes();
          }, 100);
        }
      }
    });
    // this.watching_pasalpph=true;
    this.$watch("expLinesObj.kodeacc", function (newval) {
      setTimeout(() => {
        if (this.expLinesObj.kodeacc === newval && newval) {
          //   if (newval) {
          const _selected = this.coa.find((p) => p.kodeacc == newval);
          if (_selected) {
            // console.log(' coa diketik : ', _selected);
            this.expLinesObj.glAccount = _selected.kodeacc.trim() + " | " + _selected.namaacc.trim();
            this.expLinesObj.kodeacc = _selected.kodeacc;
            this.expLinesObj.namaacc = _selected.namaacc;
            this.$forceUpdate();
            this.dimension.forEach((dim) => {
              if (_selected[dim.value]) {
                this.expLinesObj[dim.value] = _selected[dim.value];
                this.expLinesObj[`${dim.value}Txt`] = _selected[`${dim.value}Txt`];
                // this.expLinesObj[`${dim.value}Info`] = _selected[`${dim.value}Info`];
                this.expLinesObj[`${dim.value}Info`] = _selected[dim.value] + " | " + _selected[`${dim.value}Txt`];
              }
            });
          } else {
            this.expLinesObj.kodeacc = "";
            this.expLinesObj.namaacc = "";
          }
        }
      }, 500);
    });
  },
  methods: {
    async show_iDocs() {
      // switch (this.model.jenisAdv) {
      //     case '2':
      //         window.open('https://cePoIBXwvgtHwrZH8t9l7kX8cbc4TIBb:917OQCwpFIW8BHXpYWfX7Mzxn0r1L72i@idocs.metrotvnews.tv/api/docfin/browse?cat=12&view=thumb', '_blank');
      //         break;

      //     case '13':
      //         window.open('https://cePoIBXwvgtHwrZH8t9l7kX8cbc4TIBb:917OQCwpFIW8BHXpYWfX7Mzxn0r1L72i@idocs.metrotvnews.tv/api/docfin/browse?cat=13&view=thumb', '_blank');
      //         break;

      //     case '16':
      //         window.open('https://cePoIBXwvgtHwrZH8t9l7kX8cbc4TIBb:917OQCwpFIW8BHXpYWfX7Mzxn0r1L72i@idocs.metrotvnews.tv/api/docfin/browse?cat=13&view=thumb', '_blank');
      //         break;

      //     default:
      //         window.open('https://cePoIBXwvgtHwrZH8t9l7kX8cbc4TIBb:917OQCwpFIW8BHXpYWfX7Mzxn0r1L72i@idocs.metrotvnews.tv/api/docfin/browse?cat=3&view=thumb', '_blank');
      //         break;
      // }
      this.$show_iDocs();
    },
    async open_iDocs() {
      this.$open_iDocs(this.model.iDocsURL, (state) => this.isLoading = state);
    },
    onSelectLkuBudget: async function (_selected) {
      try {
        this.model.remark = _selected.uraian;
        this.model.budgetname = _selected.uraian;
        this.model.budgetnumber = _selected.nomorintern;
        // this.model.jccostname = _selected.jccostname;
        this.model.budgetinfo = _selected.nomorintern + " | " + _selected.uraian;
        this.model.nomorproduksi = _selected.noprodintern;
        // this.model.ibudgdtkey = _selected.ibudgdtkey;
        this.model.ibudghdkey = _selected.ibudghdkey;
        this.model.pjxbudgkey = _selected.pjxbudgkey;
        this.model.pjxkey = _selected.pjxhdrkey;
        this.model.DimTableKey = _selected.DimTableKey;
        // this.budgetbalance = _selected.ibbudgetamt -_selected.requestamt;

        this.model.expectreceipt = _selected.requstart ? moment(_selected.requstart).format("YYYY-MM-DD") : "";
        this.dimension.forEach((dim) => {
          if (_selected[dim.value]) {
            this.model[dim.value] = _selected[dim.value];
            this.model[`${dim.value}Txt`] = _selected[`${dim.value}Txt`];
            this.model[`${dim.value}Info`] = _selected[dim.value] + " | " + _selected[`${dim.value}Txt`];
          }
          if (dim.RelatedObj == "internalbudget") {
            this.model[`${dim.value}`] = _selected.nomorintern;
            this.model[`${dim.value}Txt`] = _selected.uraian + " # " + _selected.noprodintern;
            this.model[`${dim.value}Info`] = _selected.nomorintern + " | " + _selected.uraian + " # " + _selected.noprodintern;
          }
        });
        this.updateDimHdr = !this.updateDimHdr;

        this.lkuBudgetShow = false;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    },
    removeIB() {
      this.model.budgetname = "";
      this.model.budgetnumber = "";
      this.model.budgetinfo = "";
      this.model.nomorproduksi = "";
      this.model.ibudghdkey = "";
      this.model.pjxbudgkey = "";
      this.model.pjxkey = "";
      this.model.DimTableKey = "";
    },
    showLkuBudgetIntern: function (caller) {
      this.lkuBudgetInternCaller = caller;
      this.lkuBudgetInternShow = true;
    },
    onSelectLkuBudgetIntern: async function (ibLineObj) {
      try {
        this[this.lkuBudgetInternCaller].jccostname = ibLineObj.selected.jccostname;
        this[this.lkuBudgetInternCaller].budgetline = `${ibLineObj.selected.jccostname} ${ibLineObj.selected.jccostnote}`;
        this[this.lkuBudgetInternCaller].ibudgdtkey = ibLineObj.selected.ibudgdtkey;
        this[this.lkuBudgetInternCaller].ibudghdkey = ibLineObj.selected.ibudghdkey;
        this[this.lkuBudgetInternCaller].ibudgdtkeyflag = "NO";

        if (this.lkuBudgetInternCaller == "expLinesObj") {
          if (!this.expLinesObj.uraian) this.expLinesObj.uraian = this.expLinesObj.budgetline;
        }
        this.lkuBudgetInternShow = false;
        this.lkuBudgetInternData = ibLineObj;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    },
    tanggalBerubah: function () {
      const newval = moment(this.model.sttlDate).format("YYYY");
      if (this.tahun != newval) {
        this.tahun = newval;
        advsettle
          .getcoa({ tahun: this.tahun })
          .then((result) => {
            this.coa = result;
            if (this.coa.length == 0) {
              this.getCoa();
            }
          })
          .catch((err) => {
            console.log("get COA -> ", err);
          });
      } else if (this.coa.length == 0) {
        this.getCoa();
      }
    },
    getCoa: function () {
      this.tahun = (this.$store.state.user.tglaktif || "").substring(0, 4);
      advsettle
        .getcoa({ tahun: this.tahun })
        .then((result) => {
          this.coa = result;
        })
        .catch((err) => {
          console.log("get COA -> ", err);
        });
    },
    showLkuCashflow(callerObj) {
      this.lkuCashflowShow = true;
      this.lkuCashflowCaller = callerObj;
    },
    onSelectLkuCashflow(lkuData) {
      this.lkuCashflowData = lkuData;
      this.lkuCashflowShow = false;
      this[this.lkuCashflowCaller].cashflow = lkuData.selected.kodecash.trim() + " | " + lkuData.selected.namacash.trim();
      this[this.lkuCashflowCaller].kodecash = lkuData.selected.kodecash;
      this[this.lkuCashflowCaller].namacash = lkuData.selected.namacash;
      if ((this.model.cashflow || "") == "") {
        this.model.cashflow = lkuData.selected.kodecash.trim() + " | " + lkuData.selected.namacash.trim();
        this.model.kodecash = lkuData.selected.kodecash;
        this.model.namacash = lkuData.selected.namacash;
      }
      this.lkuCashflowShow = false;
    },
    onSelectLkuCrew: async function (lkuData) {
      this.lkuCrewData = lkuData;
      this.lkuCrewShow = false;
      if (this.adminAdv) {
        this.model.crewinfo = lkuData.selected.crewnik.trim() + " | " + lkuData.selected.crewname.trim();
        this.model.crewkey = lkuData.selected.crewkey;
        const dim = this.dimension.find((d) => d.RelatedObj == "department");
        if (dim) {
          this.model[`${dim.value}`] = lkuData.selected.departkd;
          this.model[`${dim.value}Txt`] = lkuData.selected.departemen;
          this.model[`${dim.value}Info`] = lkuData.selected.departkd + " | " + lkuData.selected.departemen;
        }
      }
      this.lkuCrewShow = false;
    },
    onSelectLkuAdv(invLookup) {
      const { selected } = invLookup;
      const advLinesItems = this.advLines.items;
      if (advLinesItems.find((x) => x.advPayKey == selected.advPayKey)) {
        toastr.warn(`No. ${selected.nomor} payment ${selected.nomorPaym} already exists in advance lines`, "Data Exists");
        return;
      }
      this.advLinesObj.advPayKey = selected.advPayKey;
      this.advLinesObj.nomorAdv = selected.nomor;
      this.advLinesObj.nomorPaym = selected.nomorPaym;
      this.advLinesObj.keterangan = selected.keterangan;
      this.advLinesObj.crewkey = selected.crewkey;
      this.advLinesObj.crewinfo = selected.crewinfo;
      this.advLinesObj.matauang = selected.matauang;
      this.advLinesObj.tglPaym = moment(selected.tglPaym).format("YYYY-MM-DD");
      this.advLinesObj.outstand = selected.outstand;
      this.advLinesObj.nilaiByr = selected.outstand;
      this.advLinesObj.cashflow = selected.cashflow;
      this.advLinesObj.kodecash = selected.kodecash;
      this.advLinesObj.advSettlAmt = selected.outstand;
      this.updateDimDtl2Hdr(selected);
      if ((this.model.keterangan || "") == "") {
        this.model.keterangan = selected.keterangan;
      }
      this.model.jenisadv = selected.jenisAdv;
      if ((this.model.cashflow || "") == "") {
        this.model.cashflow = this.advLinesObj.cashflow;
        this.model.kodecash = this.advLinesObj.kodecash;
      }
      if (this.advLines.addAdvLine == true) {
        this.advLines.selectedAdv = selected.advanKey;
      }
      this.lkuAdvShow = false;
      this.lkuAdvData = invLookup;
    },
    closeAdvLines: function () {
      const opened = this.advLines.items.find((r) => r._showDetails == true);
      if (opened) opened._showDetails = false;
    },
    addAdvLines: function () {
      this.closeAdvLines();
      this.closeApPayment();
      this.closeExpLines();
      const obj = { _showDetails: true, kodeacc: "", uraian: "", fixExpen: "0", DimTableKey: "" };
      this.advLines.selected = obj;
      this.advLines.addAdvLine = true;
      this.advLines.selectedAdv = "";
      this.advLinesObj.advSttlDtlKey = "";
      this.advLinesObj.advPayKey = "";
      this.advLinesObj.advSettlAmt = 0;
      this.advLinesObj.keterangan = "";
      this.advLinesObj.nomorAdv = "";
      this.advLinesObj.nomorPaym = "";
      this.updateDimHdr2Dtl(this.advLinesObj);
      this.advLines.items.push(obj);
      this.advLines.total = this.advLines.items.length;
      this.inputLineBerlanjut = 1;
    },
    editAdvLines: function (obj, callback) {
      this.closeAdvLines();
      this.closeApPayment();
      this.closeExpLines();
      this.advLines.addAdvLine = false;
      this.advLines.selectedAdv = "";
      this.advLines.selected = obj;
      for (var key in this.advLinesObj) {
        this.advLinesObj[key] = "";
      }
      for (var key in obj) {
        this.advLinesObj[key] = obj[key];
      }
      this.dimension.forEach((dim) => {
        if (obj[dim.value]) {
          this.advLinesObj[dim.value] = obj[dim.value];
          this.advLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
          this.advLinesObj[`${dim.value}Info`] = obj[dim.value] + " | " + obj[`${dim.value}Txt`];
        }
      });
      this.inputLineBerlanjut = 0;
      callback();
    },
    delAdvLines: function (index) {
      if (index > -1) {
        this.advLines.items.splice(index, 1);
      }
      this.advLines.total = this.advLines.items.length;
      this.calcDtlAdv();
    },
    saveAdvLines: async function (callback) {
      if (this.invalidAdvLines) {
        console.log("validation : ", this.$v.advLinesObj);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          for (var key in this.advLinesObj) {
            this.advLines.selected[key] = this.advLinesObj[key];
          }

          // this.model.crewinfo = this.model.crewinfo || this.advLinesObj.crewinfo;
          // this.model.crewkey = this.model.crewkey || this.advLinesObj.crewkey;
          this.model.crewinfo = this.advLinesObj.crewinfo;
          this.model.crewkey = this.advLinesObj.crewkey;
          this.model.matauang = this.advLinesObj.matauang;

          this.calcDtlAdv();

          this.advLines.selected._showDetails = false;
          if (callback) callback();
          if (this.inputLineBerlanjut == 1) {
            this.addAdvLines();
            this.$v.advLinesObj.$reset();
          }
        } catch (error) {
          console.log("error : ", error);
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    onSelectLkuCoa(_selected) {
      this.expLinesObj.glAccount = _selected.kodeacc.trim() + " | " + _selected.namaacc.trim();
      this.expLinesObj.kodeacc = _selected.kodeacc;
      this.expLinesObj.namaacc = _selected.namaacc;
      this.dimension.forEach((dim) => {
        if (_selected[dim.value]) {
          this.expLinesObj[dim.value] = _selected[dim.value];
          this.expLinesObj[`${dim.value}Txt`] = _selected[`${dim.value}Txt`];
          this.expLinesObj[`${dim.value}Info`] = _selected[`${dim.value}Info`];
          // this.expLinesObj[`${dim.value}Info`] = _selected[dim.value] + ' | '+ _selected[`${dim.value}Txt`];
        }
      });
      this.lkuCoaShow = false;
    },
    onSelectLkuNarasumber(_selected) {
      this.expLinesObj.id_narsum = _selected._id;
      this.expLinesObj.nama_narsum = _selected.nama;
      this.expLinesObj.npwp_narsum = _selected.npwp;
      this.expLinesObj.ktp_narsum = _selected.ktp;
      this.expLinesObj.norek_narsum = _selected.norek;
      this.expLinesObj.norek_bank_narsum = _selected.norek_bank;
      this.expLinesObj.norek_nasabah_narsum = _selected.norek_nasabah;
      this.expLinesObj.Dim9 = _selected.npwp;
      this.expLinesObj.Dim9Txt = _selected.nama;

      this.lkuNarasumShow = false;
    },
    // async onSelectLkuExpnote(_selected) {
    //     if (!(this.model.keterangan)) this.model.keterangan= _selected.namadana;
    //     const listtrx = await advsettle.detailNote(_selected);
    //     let seqNo=1;
    //     let obj;
    //     listtrx.forEach((b)=>{
    //         if (b.kasbon !=1 ){
    //             obj= {
    //                 uraian: b.uraian,
    //                 kodeacc: b.kodeacc,
    //                 namaacc: b.namaacc,
    //                 glAccount: `${b.kodeacc} | ${b.namaacc}`,
    //                 nilai: b.nilai,
    //                 reff: b.reff,
    //                 seqNo: seqNo++,
    //                 grossup: b.grossup,
    //                 kenappn: b.kenappn,
    //                 ppn: b.ppn,
    //                 nilaippn: b.nilaippn,
    //                 dppnlain: b.dppnlain,
    //                 dpp: b.dpp,
    //                 kenapph: b.kenapph,
    //                 nilaipph: b.nilaipph,
    //                 pph: b.pph,
    //                 pasalpph: b.pasalpph,
    //             },
    //             this.dimension.forEach((dim) => {
    //                 if (b[dim.value]) {
    //                     obj[dim.value] = b[dim.value];
    //                     obj[`${dim.value}Txt`] = b[`${dim.value}Txt`];
    //                 }
    //             });
    //             this.expLines.items.push(obj);
    //         }
    //     });
    //     this.expLines.total=this.expLines.items.length;
    //     this.calcDtlExp();
    //     this.lkuExpnoteShow=false;
    // },
    closeApPayment: function () {
      const opened = this.apPayment.items.find((r) => r._showDetails == true);
      if (opened) opened._showDetails = false;
    },
    addApPayment: function () {
      this.closeAdvLines();
      this.closeApPayment();
      this.closeExpLines();
      const obj = { _showDetails: true };
      this.apPayment.selected = obj;
      // for (var key in this.apPaymentObj) {
      //     this.apPaymentObj[key] = '';
      // }
      this.apPaymentObj.appaymkey = "";
      this.apPaymentObj.nilaibayar = 0;
      this.apPaymentObj.nilaibank = 0;
      this.apPaymentObj.kurskeap = 1;
      this.apPaymentObj.kurspost = 1;
      this.apPaymentObj.selisihkurs = 0;
      this.apPaymentObj.ibudghdkey = "N/A";
      this.apPaymentObj.ibudgdtkey = "N/A";
      this.apPaymentObj.ibudgdtkeyflag = "YES";

      this.apPayment.items.push(obj);
      this.apPayment.total = this.apPayment.items.length;
    },
    editApPayment: function (obj, callback) {
      this.closeAdvLines();
      this.closeApPayment();
      this.closeExpLines();
      this.apPayment.selected = obj;
      // for (var key in this.apPaymentObj) {
      //     this.apPaymentObj[key] = '';
      // }
      this.apPaymentObj.appaymkey = "";
      this.apPaymentObj.nilaibayar = 0;
      this.apPaymentObj.nilaibank = 0;
      this.apPaymentObj.kurskeap = 1;
      this.apPaymentObj.kurspost = 1;
      this.apPaymentObj.selisihkurs = 0;
      this.apPaymentObj.ibudghdkey = "N/A";
      this.apPaymentObj.ibudgdtkey = "N/A";
      this.apPaymentObj.ibudgdtkeyflag = "YES";

      for (var key in obj) {
        this.apPaymentObj[key] = obj[key];
      }
      this.apPaymentObj.ibudgdtkeyflag = this.expLinesObj.ibudgdtkey == "N/A" ? "YES" : "NO";

      callback();
    },
    delApPayment: function (index) {
      if (!this.saveEnabled) return;
      if (index > -1) {
        this.apPayment.items.splice(index, 1);
      }
      this.apPayment.total = this.apPayment.items.length;
      this.calcTotalDtlPaym();
    },
    onSelectLkuAp(invLookup) {
      this.apPaymentObj.apinvkey = invLookup.selected.apinvkey;
      this.apPaymentObj.nomor = invLookup.selected.nomor;
      this.apPaymentObj.invoice = invLookup.selected.invoice;
      this.apPaymentObj.uraian = invLookup.selected.uraian;
      this.apPaymentObj.vendor = invLookup.selected.vendor;
      this.apPaymentObj.vendorinfo = invLookup.selected.vendorinfo;
      this.model.terimadari = invLookup.selected.vendorinfo;
      this.apPaymentObj.matauang = invLookup.selected.matauang;
      this.apPaymentObj.totalinv = invLookup.selected.totalinv;
      this.apPaymentObj.outstand = invLookup.selected.outstand;
      this.apPaymentObj.nilaibayar = invLookup.selected.outstand;
      this.apPaymentObj.cashflow = invLookup.selected.cashflow;
      this.apPaymentObj.kodecash = (invLookup.selected.kodecash || "").trim();
      if (invLookup.selected.ibudgdtkey) {
        this.apPaymentObj.budgetline = `${invLookup.selected.jccostname} ${invLookup.selected.jccostnote}`;
        this.apPaymentObj.ibudgdtkey = invLookup.selected.ibudgdtkey;
        this.apPaymentObj.ibudghdkey = invLookup.selected.ibudghdkey;
        this.apPaymentObj.ibudgdtkeyflag = "NO";
      }

      this.updateDimDtl2Hdr(invLookup.selected);
      if ((this.model.uraian || "") == "") {
        this.model.uraian = invLookup.selected.uraian;
      }

      if ((this.model.cashflow || "") == "") {
        this.model.cashflow = this.apPaymentObj.cashflow;
        this.model.kodecash = this.apPaymentObj.kodecash;
        // this.model.namacash = this.apPaymentObj.namacash;
      }
      if (this.apPaymentObj.matauang.trim() == this.model.matauang.trim()) {
        this.apPaymentObj.nilaibank = invLookup.selected.outstand;
        this.apPaymentObj.kurskeap = 1;
        this.apPaymentObj.selisihkurs = 0;
      }
      this.lkuApShow = false;
      this.lkuApData = invLookup;

      tranbank
        .byrsemu(invLookup.selected)
        .then((result) => {
          this.apPaymentObj.byr_semu = result.byr_semu;
          this.apPaymentObj.byr_semu_doc = result.byr_semu_doc;
        })
        .catch((err) => {
          console.log("byrsemu -> ", err);
        });
    },
    saveApPayment: function (callback) {
      this.apPaymentObj.nilaibank = this.apPaymentObj.nilaibank || 0;
      this.apPaymentObj.nilaibayar = this.apPaymentObj.nilaibayar || 0;
      if (this.invalidApPayment) {
        console.log("validation apPayment : ", this.$v.apPaymentObj);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        // } else if (this.apPaymentObj.nilaibayar>this.apPaymentObj.outstand){
      } else if (this.apPaymentObj.nilaibayar - this.apPaymentObj.outstand > 0.01) {
        toastr.error("Payment Amount exceeds Outstanding Amount", "ERROR MESSAGE");
      } else {
        this.apPaymentObj.selisihkurs = this.apPaymentObj.nilaibank - this.apPaymentObj.nilaibayar * this.apPaymentObj.kurskeap;
        for (var key in this.apPaymentObj) {
          this.apPayment.selected[key] = this.apPaymentObj[key];
        }
        this.apPayment.selected._showDetails = false;
        this.calcTotalDtlPaym();
        this.updateDimDtl2Hdr(this.apPaymentObj);

        if (callback) callback();
      }
    },

    closeExpLines: function () {
      const opened = this.expLines.items.find((r) => r._showDetails == true);
      if (opened) opened._showDetails = false;
    },
    addExpLines: function () {
      this.closeAdvLines();
      this.closeApPayment();
      this.closeExpLines();
      this.watching_pasalpph = false;
      const obj = { _showDetails: true, kodeacc: "", uraian: "", fixExpen: "0", DimTableKey: "", ppn: this.tarifPPN, dppnlain: 100 };
      this.expLines.selected = obj;
      this.expLinesObj.advExpKey = "";
      this.expLinesObj.nilaiori = 0;
      this.expLinesObj.nilai = 0;
      this.expLinesObj.uraian = "";
      this.expLinesObj.kodeacc = "";
      this.expLinesObj.glAccount = "";
      this.expLinesObj.ppn = this.tarifPPN;
      this.expLinesObj.dppnlain = 100;
      this.expLinesObj.ibudghdkey = "N/A";
      this.expLinesObj.ibudgdtkey = "N/A";
      this.expLinesObj.ibudgdtkeyflag = "YES";

      // this.expLinesObj.uangori =`${this.model.matauang}`;
      this.updateDimHdr2Dtl(this.expLinesObj);
      this.expLines.items.push(obj);
      this.expLines.total = this.expLines.items.length;
      setTimeout(() => {
        const bfore = this.expLines.page;
        const after = Math.ceil(this.expLines.total / this.expLines.limit);
        if (bfore != after) {
          this.expLines.page = after;
          toastr.info(`Move to page ${after} of total  ${this.expLines.total} items`, "Line/Detail Expenses", 10000);
        }
      }, 100);
      this.inputLineBerlanjut = 1;
      setTimeout(() => {
        this.watching_pasalpph = true;
      }, 300);
    },
    editExpLines: function (obj, callback) {
      this.closeAdvLines();
      this.closeApPayment();
      this.closeExpLines();
      this.expLines.selected = obj;
      this.watching_pasalpph = false;
      this.expLinesObj.nilaiori = 0;
      this.expLinesObj.nilai = 0;
      this.expLinesObj.uraian = "";
      this.expLinesObj.kodeacc = "";
      this.expLinesObj.glAccount = "";
      this.expLinesObj.ppn = this.tarifPPN;
      this.expLinesObj.dppnlain = 100;
      this.expLinesObj.ibudghdkey = "N/A";
      this.expLinesObj.ibudgdtkey = "N/A";
      this.expLinesObj.ibudgdtkeyflag = "YES";
      for (var key in obj) {
        this.expLinesObj[key] = obj[key];
      }
      this.expLinesObj.ibudgdtkeyflag = this.expLinesObj.ibudgdtkey == "N/A" ? "YES" : "NO";
      this.expLinesObj.dppnlain = this.expLinesObj.dppnlain || 100;
      this.dimension.forEach((dim) => {
        if (obj[dim.value]) {
          this.expLinesObj[dim.value] = obj[dim.value];
          this.expLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
          this.expLinesObj[`${dim.value}Info`] = obj[dim.value] + " | " + obj[`${dim.value}Txt`];
        }
      });
      this.inputLineBerlanjut = 0;
      setTimeout(() => {
        this.watching_pasalpph = true;
      }, 300);
      callback();
    },
    calcTaxes: function () {
      this.expLinesObj.dppnlain = parseFloat(this.expLinesObj.dppnlain) || 100;
      this.expLinesObj.pph = this.expLinesObj.pph || 0;
      this.expLinesObj.dpp = (parseFloat(this.expLinesObj.nilai) * parseFloat(this.expLinesObj.dppnlain)) / 100;
      // if (this.expLinesObj.kenappn == 1) {
      //     this.expLinesObj.grossup = 0;
      //     this.expLinesObj.ppn = this.expLinesObj.ppn || this.tarifPPN;
      // } else {
      //     this.expLinesObj.ppn = 0;
      // }
      if (this.expLinesObj.grossup == 1) this.expLinesObj.dpp = this.expLinesObj.dpp * (100 / (100 - this.expLinesObj.pph));

      this.expLinesObj.nilaippn = 0;
      if (this.expLinesObj.kenappn == 1) this.expLinesObj.nilaippn = (parseFloat(this.expLinesObj.ppn) / 100) * this.expLinesObj.dpp;

      if (this.calcPPh == 1) this.expLinesObj.nilaipph = (this.expLinesObj.dpp * parseFloat(this.expLinesObj.pph)) / 100;
    },
    delExpLines: function (index) {
      if (index > -1) {
        const posisi = (this.expLines.page - 1) * this.expLines.limit;
        this.expLines.items.splice(posisi + index, 1);
      }
      this.expLines.total = this.expLines.items.length;
      this.calcDtlExp();
    },
    saveExpLines: async function (callback) {
      this.expLinesObj.kursori = this.expLinesObj.kursori || 1;
      if (this.invalidExpLines) {
        console.log("validation : ", this.$v.expLinesObj);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        let datadim = this.expLinesObj;
        datadim.TableName = "advsettlexpense";
        try {
          const dimValResult = await dimension.validate(datadim);
          if (dimValResult.success) {
            for (var key in this.expLinesObj) {
              this.expLines.selected[key] = this.expLinesObj[key];
            }
            this.dimension.forEach((dim) => {
              if (datadim[dim.value]) {
                this.expLines.selected[dim.value] = datadim[dim.value];
                this.expLines.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
              }
            });
            this.expLines.total = this.expLines.items.length;
            this.updateDimDtl2Hdr(datadim);
            this.calcDtlExp();
            this.expLines.selected._showDetails = false;
            if (callback) callback();
            if (this.inputLineBerlanjut == 1) {
              this.addExpLines();
              this.$v.expLinesObj.$reset();
            }
          } else {
            console.log("dimValResult : ", dimValResult);
            var msg = dimValResult.message;
            if (callback) callback(new Error(msg));
            else {
              toastr.error(msg, "ERROR MESSAGE", 10000);
            }
          }
        } catch (error) {
          console.log("error : ", error);
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    calcCashReturn: function () {
      this.model.cashvault = 0;
      this.model.balandue = 0;
      this.model.jumlah = parseFloat(this.model.jumlah || 0);
      if (this.model.jumlah - this.model.ttlExpen > 0) this.model.cashvault = this.model.jumlah - this.model.ttlExpen;
      else this.model.balandue = this.model.ttlExpen - this.model.jumlah;
    },
    save: async function () {
      this.isLoading = true;
      this.model.ratekurs = this.model.ratekurs || 1;
      if (!this.saveEnabled) {
        toastr.error("View mode cannot be Saved");
        this.isLoading = false;
        return;
      }
      if (this.invalidModel) {
        console.log("validation : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.isLoading = false;
      } else if (Math.abs(this.model.jumlah - parseFloat(this.model.ttlAdvPay)) > 0.5) {
        toastr.error("[Settlement Amount] not Balance with [Total Settlemnt Detail]", "ERROR MESSAGE", 10000);
        this.isLoading = false;
      } else {
        try {
          this.calcCashReturn();
          this.model.TableName = "advsettle";
          const dimValResult = await dimension.validate(this.model);
          if (dimValResult.success) {
            // this.model.DimTableKey = diisi dari PO;
            this.model.advanKey = this.model.advanKey || "";
            this.model.nomor = this.model.nomor || "";
            const row = {};
            for (var key in this.model) {
              row[key] = this.model[key];
            }
            row.sttlDate = moment(row.sttlDate).format("YYYY-MM-DD");
            const nomorAdv = [];
            const newAdvLines = this.advLines.items.reduce((newArr, item) => {
              if (item.advPayKey) {
                nomorAdv.push(item.nomorAdv);
                newArr.push({
                  advSttlDtlKey: item.advSttlDtlKey,
                  advPayKey: item.advPayKey,
                  advSettlAmt: item.advSettlAmt,
                });
              }
              return newArr;
            }, []);
            row.advPaymSettl = newAdvLines;
            row.nomorAdv = nomorAdv.join();

            let lineno = 1;
            let budgetLineExist = false;
            let itemValid = false;
            let newLines = this.expLines.items.reduce((newArr, item) => {
              if (item.uraian && item.nilai) {
                if (this.model.ibudghdkey) {
                  if (item.ibudgdtkey) {
                    if (item.ibudghdkey == "N/A") itemValid = true;
                    else {
                      if (this.model.ibudghdkey == item.ibudghdkey) {
                        itemValid = true;
                        budgetLineExist = true;
                      } else {
                        itemValid = false;
                        throw new Error(`Expenses "${item.uraian}" refer to Budget Line NOT FROM Internal Budget`);
                      }
                    }
                  } else itemValid = false;
                } else itemValid = true;

                if (itemValid == true) {
                  item.seqNo = lineno;
                  newArr.push(item);
                  lineno += 1;
                }
              }
              return newArr;
            }, []);
            row.lines = newLines;

            itemValid = false;
            let newApPayments = this.apPayment.items.reduce((newArr, item) => {
              if ((item.apinvkey || "") != "") {
                if (this.model.ibudghdkey) {
                  if (item.ibudgdtkey) {
                    if (item.ibudghdkey == "N/A") itemValid = true;
                    else {
                      if (this.model.ibudghdkey == item.ibudghdkey) {
                        itemValid = true;
                        budgetLineExist = true;
                      } else {
                        itemValid = false;
                        throw new Error(`AP "${item.uraian}" refer to Budget Line NOT FROM Internal Budget`);
                      }
                    }
                  } else itemValid = false;
                } else itemValid = true;

                if (itemValid == true) {
                  item.kurspost = row.ratekurs || 1;
                  newArr.push(item);
                }
              }
              return newArr;
            }, []);
            row.apPayment = newApPayments;

            if (this.model.ibudghdkey && budgetLineExist == false) {
              toastr.error("There are no reference to [Internal Budget Line]", "Error - Line/Detail Expenses'", 10000);
              this.isLoading = false;
              return;
            }

            const hasil = await advsettle.saveidocs(row);
            toastr.success(`Complete successfully, Trx.Number ${hasil.nomor}`, "Save Receipt", 10000);
            this.isLoading = false;

            if (this.inputBerlanjut == 0) {
              this.close();
            } else {
              this.saveEnabled = true;
              // const jenisAdv = this.model.jenisAdv;
              for (var key in this.model) {
                this.model[key] = "";
              }
              // this.model.jenisAdv = jenisAdv;
              this.advLines.items = [];
              this.advLines.total = 0;
              this.calcDtlAdv();
              this.expLines.items = [];
              this.expLines.total = 0;
              this.calcDtlExp();
              this.$v.model.$reset();
            }
          } else {
            this.isLoading = false;
            console.log("dimValResult : ", dimValResult);
            var msg = dimValResult.message || "Dimension validation error";
            toastr.error(msg, "ERROR MESSAGE");
          }
        } catch (error) {
          this.isLoading = false;
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    updateDimDtl2Hdr: function (dimDtl) {
      var dimHdr = this.model;
      this.dimension.forEach((dim) => {
        if (dimDtl[dim.value] && !dimHdr[dim.value]) {
          dimHdr[dim.value] = dimDtl[dim.value];
          dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
          dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`];
        }
      });
      this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
      var dimHdr = this.model;
      dimDtl = dimDtl || this.expLinesObj;
      this.dimension.forEach((dim) => {
        if (dimHdr[dim.value] && !dimDtl[dim.value]) {
          dimDtl[dim.value] = dimHdr[dim.value];
          dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
          dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`];
        }
      });
      this.updateDimDtl = !this.updateDimDtl;
    },
    calcDtlAdv: function () {
      let ttlAdvPay = 0;
      const total_description = [];
      this.advLines.items.forEach(function (item) {
        if (item.advPayKey) {
          ttlAdvPay += item.advSettlAmt || 0;
        }
        total_description.push(`${item.keterangan}`);
      });
      this.model.ttlAdvPay = ttlAdvPay;
      if (!this.model.advSttlKey) {
        this.model.keterangan = total_description.join(", ");
        this.model.jumlah = ttlAdvPay;
      }
    },
    calcDtlExp: function () {
      let ttlnetto = 0;
      this.expLines.items.forEach(function (item) {
        if (item.uraian && item.nilai) {
          // ttlnetto += (item.nilai || 0);
          if (item.grossup == 1) {
            item.nilaiexp = (item.nilai || 0) + (item.nilaippn || 0);
          } else {
            item.nilaiexp = (item.nilai || 0) - (item.nilaipph || 0) + (item.nilaippn || 0);
          }
          ttlnetto += item.nilaiexp || 0;
        }
      });
      this.apPayment.items.forEach(function (trx) {
        if (trx.apinvkey) ttlnetto = ttlnetto + parseFloat(trx.nilaibank);
      });
      this.model.ttlExpen = ttlnetto;
    },
    close() {
      //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if (this.$store.state.prevRoute.name && this.$store.state.prevRoute.name !== "advance.settlefrm") {
        router.push({ name: this.$store.state.prevRoute.name });
      } else {
        router.push({ name: "advance.home" });
      }
    },
  },
};
</script>
